// @ts-nocheck
import React, { Component, useState } from 'react';

import Select from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';

export default class SelectCustomer extends Component<any & { excludeNonAdmins?: boolean }, any> {
  static defaultProps = {
    placeholder: 'Select customer email',
  };

  async fetchCustomer(text) {
    if (!text) {
      return [];
    }
    try {
      const results = await apiFetch(null, `corp-api/find/customers`, {
        query: {
          search: text,
          ...(this.props.excludeNonAdmins && { excludeNonAdmins: 'true' }),
        },
      });
      const options = results.users.map(user => ({
        label: `${user.email} (${user.id})`,
        value: user.id,
      }));

      return {
        options,
      };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      return [];
    }
  }

  render() {
    return (
      <React.Fragment>
        <Select
          filterOption={() => true}
          {...this.props}
          loadOptions={this.fetchCustomer.bind(this)}
        />
      </React.Fragment>
    );
  }
}

// Wrapper to select a customer when you have only the ID and not the label
export const SelectCustomerFromId = ({ id, onChange, ...props }) => {
  const [value, setValue] = useState<{ value: string; label: string } | undefined>(undefined);
  React.useEffect(() => {
    if (id && !value) {
      (async () => {
        const { email } = await apiFetch(null, `corp-api/find/user-email/${id}`);
        setValue({ value: id, label: email });
      })();
    }
  }, [id]);
  const onValueChange = value => {
    setValue(value);
    onChange(value.value);
  };
  return <SelectCustomer {...props} value={value} onChange={onValueChange} />;
};

// thin wrapper to hold state for components that only want to read changes
export const SelectCustomerUncontrolled = ({ onChange, ...props }) => {
  const [value, setValue] = useState();
  const onValueChange = value => {
    setValue(value);
    onChange(value);
  };
  return <SelectCustomer {...props} value={value} onChange={onValueChange} />;
};
